/*
 * @Author: Mike Cottingham 
 * @Date: 2019-01-22 21:15:10 
 * @Last Modified by: Mike Cottingham
 * @Last Modified time: 2019-01-22 21:41:27
 */

// import * as actions from '../actions'
import * as actions from '../../invoice/actions'

import { Checkbox, ExpansionPanel } from "material-ui"
import { ExpansionPanelDetails } from "material-ui"
import { ExpansionPanelSummary } from "material-ui"
import FontAwesomeIcon from "@fortawesome/react-fontawesome"
import React from "react"
import { Typography } from "material-ui"
import { bindActionCreators } from 'redux'
import { connect, useSelector } from 'react-redux'
import { faChevronDown } from "@fortawesome/fontawesome-free-solid"
import styled from 'styled-components'
import { Button } from 'material-ui'
import { useEffect } from 'react'
import { useState } from 'react'
import ClientAppointmentListItem from "./ClientAppointmentListItem"
import layout from "../../layout"
import _ from "lodash"
import core from "../../core";
import moment from "moment"
import { exportToPdf, exportToZip, getInvoicesNumbers } from "../../../service/api";
import { faSpinner } from '@fortawesome/fontawesome-free-solid'

const dispatchToProps = (dispatch) => (
  bindActionCreators({
    ...actions
  }, dispatch)
)

const stateToProps = (state, props) => {
  return {}
}

const Details = styled(ExpansionPanelDetails)`
  padding: 0 0 1rem 0;
`

const Summary = styled(ExpansionPanelSummary)`
  padding: 0 1rem;
  margin: 0 !important;
`

const FundingExpansionPanel = ({title, onClick, isDirectBill, appointments, exportInvoices, ...props}) => {
  const [selected, setSelected] = useState([])
  const [expanded, setExpanded] = useState(false)
  const [loading, setLoading] = useState(false)
  const isAdmin = useSelector(state => state.auth.profile.isAdmin)

  const checkboxHandler = (e) => {
    e.stopPropagation()
    if (selected.length) {
      setSelected([])
    } else {
      setSelected([...appointments])
      setExpanded(true)
    }
  }

  const singleExport = async  (invoice) => {
    const {client, counsellors, appointments} = invoice
    console.log(client, invoice)
    const exportAppointments = []
    let totalTax = 0
    let total = 0
    let totalRate = 0
    let initialreportId = undefined

    appointments.forEach((element, i) => {
      if (element.paymentSource === "ICBC" && element.type.toLowerCase().includes('initial report')) {
        initialreportId = i
      } else if (!(i === (initialreportId + 1))) {
        const price = Number(element.price) || 0
        const tax = (price * core.constants.taxRate)
        const linePrice = price + tax

        const appointmentsForExport = {
            description: element.type,
            date: moment(element.date).format("MMM DD, YYYY"),
            rate: price,
            GST: +tax.toFixed(2),
            total: +linePrice.toFixed(2)
        }
        
        exportAppointments.push(appointmentsForExport)

        total += linePrice
        totalTax += tax
        totalRate += price
      }
    })

    const dataForExport = [
      {
        id: +appointments[0].id,
        therapist_name: counsellors[0],
        date: core.utils.formatDate(new Date()),
        claim_number: client.claimNumber || "",
        first_name: client.firstName,
        last_name: client.lastName,
        appointments: [...exportAppointments],
        result_rates: totalRate.toFixed(2),
        result_GST: totalTax.toFixed(2),
        total_result: total.toFixed(2),
      }
    ]

    const exportedInvoice = [{
      billTo: "ICBC",
      invoiceNumber: String(Date.now()).slice(-3),
      invoiceDate: moment(invoice.date).subtract(10, 'days').calendar(),
      therapistName: counsellors[0],
      asReceipt: false,
      isExportDisabled: false,
      invoice: {
        ...invoice, 
        icbcClaimNumber: client.claimNumber, 
        numberOfAppointments: exportAppointments.length, 
        total
      }
    }]
    
    try {
      setLoading(true)
      const response = await exportToPdf(dataForExport)
      
      const invoiceNumber = response.headers.invoice_number
      const fileName = client.claimNumber 
        ? `${invoiceNumber}-${client.claimNumber}-${client.firstName} ${client.lastName}.pdf`
        : `${invoiceNumber}-${client.firstName} ${client.lastName}.pdf`


      exportedInvoice[0].invoiceNumber = invoiceNumber
      downloadFile(response, fileName)
      exportInvoices(exportedInvoice)
    } catch(e) {
      console.log(e)
    } finally {
      setLoading(false)
    }
        
  }

  const downloadFile = (file, fileName) => {
    const url = window.URL.createObjectURL(new Blob([file.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click((e) => e.preventDefault());
  }

  const exportHandler = async (e) => {
    e.stopPropagation()

    if(selected.length < 5) {  
      for (const element of selected) {
        await singleExport(element)

        setSelected(prev => {
            const updatedSelect = prev.filter(el => el.id !== element.id)
            return [...updatedSelect]
          }
        )
      }   
    } else {
      let data = []
      const exportedInvoicesList = []
      const fileName = `${selected[0].paymentSource} - ${selected.length} appointments.zip`
      
      selected.forEach((element, i) => {
        const {client, counsellors, appointments} = element
        
        const exportAppointments = []
        let totalTax = 0
        let total = 0
        let totalRate = 0
        let initialreportId = undefined

        appointments.forEach((element, i) => {
          if(element.paymentSource === "ICBC" && element.type.toLowerCase().includes('initial report')) {
            initialreportId = i
          } else if (!(i === (initialreportId + 1))) {
            const price = Number(element.price) || 0
            const tax = (price * core.constants.taxRate)
            const linePrice = price + tax

            const appointmentsForExport = {
                description: element.type,
                date: moment(element.date).format("MMM DD, YYYY"),
                rate: price,
                GST: +tax.toFixed(2),
                total: +linePrice.toFixed(2)
            }
            exportAppointments.push(appointmentsForExport)

            total += linePrice
            totalTax += tax
            totalRate += price
          }
        })

        const dataForExport = {
          id: +appointments[0].id,
          therapist_name: counsellors[0],
          date: core.utils.formatDate(new Date()),
          claim_number: client.claimNumber || "",
          first_name: client.firstName,
          last_name: client.lastName,
          appointments: [...exportAppointments],
          result_rates: totalRate.toFixed(2),
          result_GST: totalTax.toFixed(2),
          total_result: total.toFixed(2),
        }

        data.push(dataForExport)

        const exportedInvoice = {
          id: +appointments[0].id,
          billTo: "ICBC",
          invoiceNumber: null,
          invoiceDate: moment(element.date).format("MMM DD, YYYY"),
          therapistName: counsellors[0],
          asReceipt: false,
          isExportDisabled: false,
          invoice: {
            ...element, 
            icbcClaimNumber: client.claimNumber, 
            numberOfAppointments: exportAppointments.length, 
            total
          }

        }

        exportedInvoicesList.push(exportedInvoice)
      });    
      
      try {
        setLoading(true)

        const response = await exportToZip(data)
        const numbersList = await getInvoicesNumbers(+response.headers.operation_id)
        
        numbersList.forEach(({invoiceNumber, invoiceId}) => {
          exportedInvoicesList.forEach(invoice => {
            if (invoice.id === invoiceId) {
              invoice.invoiceNumber = invoiceNumber
            }
          }) 
        })
        downloadFile(response, fileName)
        exportInvoices(exportedInvoicesList)
      } catch(e) {
        console.log(e)
      } finally {
        setLoading(false)
        setSelected([])
      }
    }
  }

  const onChange = (e, appointment, checked) => {
    e.stopPropagation()
    
    if (checked) {
      const newSelected = selected.filter(el => el.id !== appointment.id)
      setSelected([...newSelected])
    } else {
      setSelected([...selected, appointment])
    }
    
  }
  const listItems = appointments.map((clientAppointment, i) => (
    <ClientAppointmentListItem 
      clientAppointment={clientAppointment} 
      selectedItems={selected}
      key={`${clientAppointment.id}-${i}`} 
      onClick={onClick(clientAppointment)}
      onChange={onChange}
      singleExport={singleExport}
    />
  ))
  
  const showExportElements = isDirectBill && isAdmin
  return (
    <ExpansionPanel expanded={expanded} onChange={(e, exp) => {
      exp ? setExpanded(true) : setExpanded(false)
    }}
    classes={{
      expanded: {
        margin: 0,
        minHeight: 'auto !important',
      }
    }}>
      <Summary expandIcon={<FontAwesomeIcon icon={faChevronDown} /> } style={{paddingLeft: !showExportElements ? 53 : 16}}>
        <Typography component={'span'}>
          {
            showExportElements && 
              <Checkbox 
              onClick={checkboxHandler}
              className="select-all-checkbox"
              checked={selected.length}  
              />
          }
          
          {title}
        </Typography>
        {
          showExportElements && 
            <Button 
              color="secondary" 
              variant="raised" 
              className="export-all-btn" 
              disabled={selected.length <= 1 || loading} 
              onClick={exportHandler}
            >
              {
                loading 
                  ? <FontAwesomeIcon icon={faSpinner} spin />
                  : "Export All"
              }
            </Button>
        }
      </Summary>
      <Details>
        <layout.components.Container>
          {listItems}
        </layout.components.Container>
      </Details>
    </ExpansionPanel>
  )
}

export default connect(stateToProps,dispatchToProps)(FundingExpansionPanel)